import React from 'react';

/**
 * Utilitaires de validation pour les formulaires
 */

export const validators = {
  /**
   * Valide un email
   */
  email: (value) => {
    if (!value) return 'Email est requis';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) return 'Email invalide';
    return null;
  },

  /**
   * Valide un prénom/nom
   */
  name: (value, fieldName = 'Nom') => {
    if (!value) return `${fieldName} est requis`;
    if (value.length < 2) return `${fieldName} doit contenir au moins 2 caractères`;
    if (value.length > 50) return `${fieldName} ne doit pas dépasser 50 caractères`;
    if (!/^[a-zA-ZÀ-ÿ\s'-]+$/.test(value)) return `${fieldName} contient des caractères invalides`;
    return null;
  },

  /**
   * Valide un mot de passe
   */
  password: (value) => {
    if (!value) return 'Mot de passe est requis';
    if (value.length < 8) return 'Mot de passe doit contenir au moins 8 caractères';
    if (!/[A-Z]/.test(value)) return 'Mot de passe doit contenir au moins une majuscule';
    if (!/[a-z]/.test(value)) return 'Mot de passe doit contenir au moins une minuscule';
    if (!/[0-9]/.test(value)) return 'Mot de passe doit contenir au moins un chiffre';
    if (!/[!@#$%^&*]/.test(value)) return 'Mot de passe doit contenir au moins un caractère spécial (!@#$%^&*)';
    return null;
  },

  /**
   * Valide la confirmation du mot de passe
   */
  passwordConfirm: (value, password) => {
    if (!value) return 'Confirmation du mot de passe est requise';
    if (value !== password) return 'Les mots de passe ne correspondent pas';
    return null;
  },

  /**
   * Valide un champ requis
   */
  required: (value, fieldName = 'Ce champ') => {
    if (!value || (typeof value === 'string' && !value.trim())) {
      return `${fieldName} est requis`;
    }
    return null;
  },
};

/**
 * Hook pour gérer la validation des formulaires
 */
export const useFormValidation = (initialValues, onSubmit) => {
  const [values, setValues] = React.useState(initialValues);
  const [errors, setErrors] = React.useState({});
  const [touched, setTouched] = React.useState({});
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
    
    // Valider en temps réel si le champ a été touché
    if (touched[name]) {
      validateField(name, value);
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    validateField(name, value);
  };

  const validateField = (name, value) => {
    // À implémenter selon les besoins spécifiques
    setErrors((prev) => ({
      ...prev,
      [name]: null,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await onSubmit(values);
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setValues(initialValues);
    setErrors({});
    setTouched({});
  };

  return {
    values,
    errors,
    touched,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    resetForm,
    setValues,
    setErrors,
    setTouched,
  };
};
